<template>
  <div class="pt-3">
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <title-page title="Implementing Partner" />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="
          permissions.includes('UPCM') ||
          role == 'SUPERADMIN' ||
          role == 'VENDOR'
        "
      >
        <div class="d-flex justify-end">
          <v-btn
            class="bg_default text-capitalize rounded-lg"
            depressed
            dark
            @click="createVendor"
            >+ Add Vendor</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <!--  ========================================================================= toolbar -->

    <v-card class="rounded_max mt-5" flat>
      <div class="pa-3">
        <v-card flat class="rounded-lg" color="#f6f6f6">
          <v-row no-gutters>
            <v-col cols="12" md="5">
              <div class="pa-2">
                <v-text-field
                  placeholder="Search Vendor"
                  solo
                  v-model="find"
                  @keyup="fetchData"
                  hide-details
                  dense
                  prepend-inner-icon="mdi-magnify"
                  flat
                ></v-text-field>
              </div>
            </v-col>
            <!-- <v-col cols="12" md="2">
              <div class="pa-2">
                <v-select
                  dense
                  hide-details
                  :items="optStatus"
                  item-text="txt"
                  item-value="val"
                  v-model="status"
                  @change="fetchData()"
                  placeholder="Filter Status"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col> -->
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-menu
                  v-model="menuLimit"
                  bottom
                  :nudge-bottom="55"
                  elevation="0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      class="text-capitalize color_txt"
                      height="38px"
                      block
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                      ><p class="default_txt">Show : {{ limit }}</p>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="popup_radius" outlined elevation="0">
                    <v-list>
                      <v-list-item link @click="changeLimit(5)">
                        <v-list-item-title>5</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(10)">
                        <v-list-item-title>10</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(50)">
                        <v-list-item-title>50</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(100)">
                        <v-list-item-title>100</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <!--  ========================================================================= data table -->
      <div>
        <v-skeleton-loader
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
          >
            <template v-slot:[`item.member`]="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      depressed
                      color="blue"
                      dark
                      class="text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      :to="`/admin/ma/${item.id}/user-vendor`"
                    >
                      <v-icon dark small class="mr-1">
                        mdi-account-group
                      </v-icon>
                      Member
                    </v-btn>
                  </template>
                  <span>Manage User Vendor</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-btn
                  fab
                  depressed
                  x-small
                  class="mr-2"
                  color="blue"
                  @click="updateVendor(item)"
                  :disabled="
                    permissions.includes('UPCM') ||
                    role == 'VENDOR' ||
                    role == 'SUPERADMIN'
                      ? false
                      : true
                  "
                >
                  <v-icon color="white">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  fab
                  :disabled="
                    permissions.includes('UPCM') ||
                    role == 'VENDOR' ||
                    role == 'SUPERADMIN'
                      ? false
                      : true
                  "
                  color="red"
                  depressed
                  x-small
                  @click="deleteVendor(item)"
                >
                  <v-icon color="white">mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>
    <div class="text-center pa-3" v-if="dataSet">
      <v-pagination
        v-model="page"
        color="#006341"
        @input="fetchData"
        :length="last_page"
      ></v-pagination>
    </div>
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitlePage from "../../../components/atom/titlePage.vue";
// import dialogCreate from "../../dialog/dialogMedium";
import DialogSmall from "../../dialog/dialogSmall.vue";

export default {
  name: "listTanoto",
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  components: {
    // dialogCreate,
    TitlePage,
    DialogSmall,
  },
  data() {
    return {
      loading: false,
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      dataSet: null,
      page: 1,
      limit: 5,
      total: null,
      last_page: null,
      find: "",
      status: "",
      optStatus: [
        { txt: "Active", val: 1 },
        { txt: "No Active", val: 2 },
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: "Full Name",
          align: "start",
          value: "name",
        },

        {
          text: "Contact Person",
          align: "start",
          value: "contact_person",
        },
        { text: "Phone Number", sortable: false, value: "phone_number" },
        {
          text: "Member",
          align: "start",
          value: "member",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],

      menuLimit: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/vendor?filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    createVendor() {
      this.d_type = "c_vendor";
      this.d_title = "Create Vendor";
      this.d_create = true;
    },

    updateVendor(item) {
      this.d_type = "u_vendor";
      this.d_title = "Update Vendor";
      this.d_create = true;
      this.inventory = item;
    },
    deleteVendor(item) {
      this.d_type = "d_vendor";
      this.d_title = "Delete Vendor";
      this.d_small = true;
      item["d_width"] = "300px";
      this.inventory = item;
    },

    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },

    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_table"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>

<style>
.v-pagination__item {
  box-shadow: none !important;
}
.v-pagination__navigation {
  box-shadow: none !important;
}
</style>
